import { render, staticRenderFns } from "./ImagePositionSelector.vue?vue&type=template&id=22f0e110&scoped=true&lang=pug&"
import script from "./ImagePositionSelector.vue?vue&type=script&lang=ts&"
export * from "./ImagePositionSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePositionSelector.vue?vue&type=style&index=0&id=22f0e110&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0e110",
  null
  
)

export default component.exports